import { normalizeCourseId } from '@/utils/courseId';

const ROOT_KEY = 'tcp.adaptiveRtDraft.v1';
export const ADAPTIVE_RT_DRAFT_VERSION = 1;

function readRoot() {
  try {
    const raw = sessionStorage.getItem(ROOT_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeRoot(map) {
  try {
    sessionStorage.setItem(ROOT_KEY, JSON.stringify(map));
  } catch {
    // quota / private mode
  }
}

/**
 * @param {number|string|null} courseId
 * @returns {import('./adaptiveRtDraft').AdaptiveRtDraftV1|null}
 */
export function readAdaptiveRtDraft(courseId) {
  const id = normalizeCourseId(courseId);
  if (id == null) return null;
  const map = readRoot();
  const draft = map[String(id)];
  if (!draft || draft.version !== ADAPTIVE_RT_DRAFT_VERSION) return null;
  return draft;
}

/**
 * @param {number|string|null} courseId
 * @param {import('./adaptiveRtDraft').AdaptiveRtDraftV1|null} draft
 */
export function writeAdaptiveRtDraft(courseId, draft) {
  const id = normalizeCourseId(courseId);
  if (id == null || !draft) return;
  const map = readRoot();
  map[String(id)] = draft;
  writeRoot(map);
}

export function clearAdaptiveRtDraft(courseId) {
  const id = normalizeCourseId(courseId);
  if (id == null) return;
  const map = readRoot();
  delete map[String(id)];
  writeRoot(map);
}

export function clearAllAdaptiveRtDrafts() {
  try {
    sessionStorage.removeItem(ROOT_KEY);
  } catch {
    // ignore
  }
}
